/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CreateEventDto } from '../../models/create-event-dto';
import { EventItem } from '../../models/event-item';

export interface EventControllerCreate$Params {
  monitoringId: number;
      body: CreateEventDto
}

export function eventControllerCreate(http: HttpClient, rootUrl: string, params: EventControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>> {
  const rb = new RequestBuilder(rootUrl, eventControllerCreate.PATH, 'post');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EventItem;
      }>;
    })
  );
}

eventControllerCreate.PATH = '/monitoring/{monitoringId}/events';
